const mutations = {
    Micro_Apps_Url_Params(state, data) {
        state.microAppsUrlParams = data;
        // localStorage.setItem('microAppsUrlParams', JSON.stringify(data));
    },
    Customer_Transaction(state, data) {
        localStorage.setItem('mid', data.marketplaceId);
        localStorage.setItem('tid', data.txnId);
        state.marketplaceId = data.marketplaceId;
        state.transactionId = data.txnId;
    },
    OTHER_GST_DATA(state, data) {
        state.gstDataQuery = data;
    },
    UDYAM_DATA_PASS(state, data) {
        state.udyamDataPass = data;
    },
    SET_VIDEO_KYC_SCHEDULED_DATE_TIME(state, data) {
        state.videoKycScheduledDateTime = data;
    },
    FSSAI_DATA_PASS(state, data) {
        state.fssaiDataPass = data;
    },
    FDA_DATA_PASS(state, data) {
        state.fdaDataPass = data;
    },
    SHOP_AND_ESTABLISHMENT_DATA_PASS(state, data) {
        state.shopAndEstablishmentDataPass = data;
    },
    OTHER_DATA_PASS(state, data) {
        state.otherDataPass = data;
    }
};
export default mutations;
